import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { SpinnerButtonComponent } from "../../../common/components/spinnerButton";
import { ClientService } from "../../../common/services/client.service";
import { LocalizationService } from "../../../common/services/localization";
import { getSafeRedirectUrl } from "../../../common/helpers/redirect.helper";
import { isOneWebSessionCookieEnabled, mintOneWebSessionCookie } from "../../../common/helpers/oneWebSession.helper";
import storage from "../../../common/storage";

@Component({
    selector: "app-login",
    template: require("./login.component.html").default,
    styles: [require("../../../common/styles/index.scss").default, require("../home-page.scss").default],
})
export class LoginComponent implements OnInit {
    @ViewChild("spinnerButton") spinnerButton: SpinnerButtonComponent;
    @ViewChild("forgetPasswordButton") forgetPasswordButton: SpinnerButtonComponent;

    loginPasswordBreachedMessage: "";
    invalidEmailOrPhoneNumber = false;
    loginPasswordBreached = false;
    spondIsOffline = false;
    redirectUrl: string;
    tooManyAttempts = false;

    model = {
        emailOrPhoneNumber: { invalid: false, value: "" },
        password: { invalid: false, value: "" },
    };

    constructor(
        private _i18n: LocalizationService,
        private client: ClientService,
        private route: ActivatedRoute,
        private router: Router,
    ) {}

    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            this.redirectUrl = params["redirect"];
        });
        if (this.client.isLoggedIn()) {
            this.redirectToClient();
        }
    }

    i18n(key): string {
        return this._i18n.dict()[key];
    }

    redirectToClient() {
        window.location.href = "/client";
    }

    resetPassword() {
        this.router.navigate(["/forgot-password"]);
    }

    submit() {
        const emailOrPhoneNumber = this.model.emailOrPhoneNumber;

        if (emailOrPhoneNumber.value.match(/^\d+$/)) {
            emailOrPhoneNumber.invalid = true;
            return;
        } else {
            emailOrPhoneNumber.invalid = false;
        }

        this.spinnerButton.isSpinning = true;
        this.client.login(emailOrPhoneNumber.value, this.model.password.value).subscribe(
            async (data: any) => {
                if (data.accessToken?.token) {
                    storage.setItem("token", data.accessToken.token);
                    storage.setItem("tokenExpiration", data.accessToken.expiration);
                    storage.setItem("refreshToken", data.refreshToken.token);
                    storage.setItem("refreshTokenExpiration", data.refreshToken.expiration);
                }
                if (data.phoneNumber && data.phoneNumber.length > 0) {
                    const params = {
                        phoneNumber: data.phoneNumber,
                        token: data.accessToken ? data.accessToken.token : data.token,
                        redirectUrl: this.redirectUrl,
                    };
                    this.router.navigate(["/verify-code"], { queryParams: params });
                } else {
                    if (await isOneWebSessionCookieEnabled()) {
                        await mintOneWebSessionCookie(data);
                    }
                    const safeRedirectUrl = getSafeRedirectUrl(this.redirectUrl);
                    if (safeRedirectUrl) {
                        window.location.href = safeRedirectUrl;
                    } else {
                        this.redirectToClient();
                    }
                }
            },
            (err) => {
                this.spondIsOffline = false;
                this.invalidEmailOrPhoneNumber = false;
                this.loginPasswordBreached = false;

                if (err.status === 503) {
                    this.spondIsOffline = true;
                } else if (err.json().errorKey === "outOfLoginAttempts") {
                    this.tooManyAttempts = true;
                } else if (err.json().errorKey === "loginPasswordBreached" || err.json().errorCode === 400) {
                    this.loginPasswordBreached = true;
                    this.loginPasswordBreachedMessage = err.json().message;
                } else {
                    this.invalidEmailOrPhoneNumber = true;
                }
                this.spinnerButton.isSpinning = false;
            },
        );
    }
}
